module.exports = __webpack_public_path__ + "img/img7.1fd0e616.png";